import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetAllTicketApi = (params) => api.get(`ticket/user/get-all-tickets?${qs(params)}`);
export const GetTicketPriorityApi = () => api.get('dropdown/getpriority');
export const GetTicketQueryTypeApi = () => api.get('ticket/getall-ticket-query');
export const GenerateTicketApi = (data) => api.post('ticket/create-ticket', data);
export const GetTicketByIdApi = (ticketId) => api.get(`ticket/get-ticket-details-byid/${ticketId}`);
export const UpdateTicketApi = (data) => api.post('ticket/update-ticket-status', data);
export const GetTicketChatApi = (data, headers) => api.post('ticket/add-ticket-detail', data, headers);